/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises6Inputs */

const en__field__enum_schoolname_berufliches_gymnasium_des_main_kinzig_kreises6 = /** @type {(inputs: _Field__Enum_Schoolname_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelnhausen`)
};

const de__field__enum_schoolname_berufliches_gymnasium_des_main_kinzig_kreises6 = /** @type {(inputs: _Field__Enum_Schoolname_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berufliches Gymnasium des Main-Kinzig-Kreises`)
};

/**
* | output |
* | --- |
* | "Gelnhausen" |
*
* @param {_Field__Enum_Schoolname_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_berufliches_gymnasium_des_main_kinzig_kreises6 = /** @type {((inputs?: _Field__Enum_Schoolname_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_berufliches_gymnasium_des_main_kinzig_kreises6(inputs)
	return de__field__enum_schoolname_berufliches_gymnasium_des_main_kinzig_kreises6(inputs)
});
export { _field__enum_schoolname_berufliches_gymnasium_des_main_kinzig_kreises6 as "_field__enum_schoolName_Berufliches_Gymnasium_des_Main_Kinzig_Kreises" }